import { Badge } from "@/components/ui/PageHeader";

const DAYS: [string, string][] = [
  ["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"],
];

/**
 * `openNow` as the server reads it. Null says nothing: no hours today, hours
 * it cannot read ("by appointment"), or a state with two clocks. Never "Closed".
 */
export function OpenNowBadge({ openNow }: { openNow: boolean | null }) {
  if (openNow === null) return null;
  return openNow ? <Badge variant="green">open now</Badge> : <Badge variant="gray">closed now</Badge>;
}

/** The stated hours, a row per day; a day not stated says so. */
export function HoursTable({ hours }: { hours: Record<string, string | null> | null }) {
  if (!hours || Object.values(hours).every((v) => !v)) {
    return <p className="text-sm text-gray-500">Hours not listed</p>;
  }
  return (
    <dl className="grid grid-cols-[3rem_1fr] gap-x-3 gap-y-1 text-sm">
      {DAYS.map(([key, label]) => (
        <div key={key} className="contents">
          <dt className="text-gray-500">{label}</dt>
          <dd className={hours[key] ? "text-gray-900" : "text-gray-400"}>{hours[key] ?? "not stated"}</dd>
        </div>
      ))}
    </dl>
  );
}
